/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CategoriesResponseWithPaginationDto } from '../models';
// @ts-ignore
import type { CategoryDto } from '../models';
/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение списка категорий по фильтрам
         * @param {number} [id] ID конкретного бренда
         * @param {Array<number>} [ids] Массив ID брендов
         * @param {string} [query] Строка для поиска по названию или описанию
         * @param {number} [limit] Лимит для пагинации
         * @param {number} [cursor] Смещение для пагинации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategories: async (id?: number, ids?: Array<number>, query?: string, limit?: number, cursor?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение всех категорий
         * @param {boolean} [hideEmpty] Скрыть категории, в которых нет товаров (0 товаров в product_view по поддереву)
         * @param {boolean} [withCount] Добавить productCount в каждую категорию (с роллапом по поддереву)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategoriesTree: async (hideEmpty?: boolean, withCount?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }

            if (withCount !== undefined) {
                localVarQueryParameter['withCount'] = withCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение списка категорий по фильтрам
         * @param {number} [id] ID конкретного бренда
         * @param {Array<number>} [ids] Массив ID брендов
         * @param {string} [query] Строка для поиска по названию или описанию
         * @param {number} [limit] Лимит для пагинации
         * @param {number} [cursor] Смещение для пагинации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryControllerGetCategories(id?: number, ids?: Array<number>, query?: string, limit?: number, cursor?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoriesResponseWithPaginationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryControllerGetCategories(id, ids, query, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.categoryControllerGetCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение всех категорий
         * @param {boolean} [hideEmpty] Скрыть категории, в которых нет товаров (0 товаров в product_view по поддереву)
         * @param {boolean} [withCount] Добавить productCount в каждую категорию (с роллапом по поддереву)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryControllerGetCategoriesTree(hideEmpty?: boolean, withCount?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryControllerGetCategoriesTree(hideEmpty, withCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.categoryControllerGetCategoriesTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение списка категорий по фильтрам
         * @param {CategoryApiCategoryControllerGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategories(requestParameters: CategoryApiCategoryControllerGetCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CategoriesResponseWithPaginationDto> {
            return localVarFp.categoryControllerGetCategories(requestParameters.id, requestParameters.ids, requestParameters.query, requestParameters.limit, requestParameters.cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение всех категорий
         * @param {CategoryApiCategoryControllerGetCategoriesTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategoriesTree(requestParameters: CategoryApiCategoryControllerGetCategoriesTreeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.categoryControllerGetCategoriesTree(requestParameters.hideEmpty, requestParameters.withCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for categoryControllerGetCategories operation in CategoryApi.
 * @export
 * @interface CategoryApiCategoryControllerGetCategoriesRequest
 */
export interface CategoryApiCategoryControllerGetCategoriesRequest {
    /**
     * ID конкретного бренда
     * @type {number}
     * @memberof CategoryApiCategoryControllerGetCategories
     */
    readonly id?: number

    /**
     * Массив ID брендов
     * @type {Array<number>}
     * @memberof CategoryApiCategoryControllerGetCategories
     */
    readonly ids?: Array<number>

    /**
     * Строка для поиска по названию или описанию
     * @type {string}
     * @memberof CategoryApiCategoryControllerGetCategories
     */
    readonly query?: string

    /**
     * Лимит для пагинации
     * @type {number}
     * @memberof CategoryApiCategoryControllerGetCategories
     */
    readonly limit?: number

    /**
     * Смещение для пагинации
     * @type {number}
     * @memberof CategoryApiCategoryControllerGetCategories
     */
    readonly cursor?: number
}

/**
 * Request parameters for categoryControllerGetCategoriesTree operation in CategoryApi.
 * @export
 * @interface CategoryApiCategoryControllerGetCategoriesTreeRequest
 */
export interface CategoryApiCategoryControllerGetCategoriesTreeRequest {
    /**
     * Скрыть категории, в которых нет товаров (0 товаров в product_view по поддереву)
     * @type {boolean}
     * @memberof CategoryApiCategoryControllerGetCategoriesTree
     */
    readonly hideEmpty?: boolean

    /**
     * Добавить productCount в каждую категорию (с роллапом по поддереву)
     * @type {boolean}
     * @memberof CategoryApiCategoryControllerGetCategoriesTree
     */
    readonly withCount?: boolean
}

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI {
    /**
     * 
     * @summary Получение списка категорий по фильтрам
     * @param {CategoryApiCategoryControllerGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public categoryControllerGetCategories(requestParameters: CategoryApiCategoryControllerGetCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).categoryControllerGetCategories(requestParameters.id, requestParameters.ids, requestParameters.query, requestParameters.limit, requestParameters.cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение всех категорий
     * @param {CategoryApiCategoryControllerGetCategoriesTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public categoryControllerGetCategoriesTree(requestParameters: CategoryApiCategoryControllerGetCategoriesTreeRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).categoryControllerGetCategoriesTree(requestParameters.hideEmpty, requestParameters.withCount, options).then((request) => request(this.axios, this.basePath));
    }
}

